require( '@wpmudev/shared-ui/dist/js/_src/accordion' );
require( '@wpmudev/shared-ui/dist/js/_src/dialog-slider' );
require( '@wpmudev/shared-ui/dist/js/_src/dropdowns' );
require( '@wpmudev/shared-ui/dist/js/_src/modal-dialog' );
require( '@wpmudev/shared-ui/dist/js/_src/notifications' );
require( '@wpmudev/shared-ui/dist/js/_src/password' );
require( '@wpmudev/shared-ui/dist/js/_src/reviews' );
require( '@wpmudev/shared-ui/dist/js/_src/scores' );
require( '@wpmudev/shared-ui/dist/js/_src/select2.full' );
require( '@wpmudev/shared-ui/dist/js/_src/select2' );
require( '@wpmudev/shared-ui/dist/js/_src/side-tabs' );
require( '@wpmudev/shared-ui/dist/js/_src/sidenav-input' );
require( '@wpmudev/shared-ui/dist/js/_src/sticky-box' );
require( '@wpmudev/shared-ui/dist/js/_src/tabs' );
